import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import ExcelDataExportSearchParams from './ExcelDataExportSearchParams';
import RoleService from '../../../Services/roleService';

export default class ExcelDataExportWindowDescription {
  static titleForCreate = 'Excel Data Export';
  static titleForEdit = 'Excel Data Export';
  static itemType = ExcelDataExportSearchParams;
  static serviceFunction = ReportRunnerService.CreateDataExport;
  static waitForServiceFunction = () => false;
  static finishButtonLabel = 'Export';
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Report',
          label: 'Report',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ExcelDataExportWindowDescription.GetExcelDataReportTypes(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'FromDate',
          label: 'From',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ToDate',
          label: 'To',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Office',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeOrGroupForReportMultiSelect,
          disabled: (item) => ExcelDataExportWindowDescription.isOfficeDisabled(item),
          validityChecker: ExcelDataExportWindowDescription.forRequiredOfficeField,
        },
        {
          fieldName: 'Client',
          label: 'Client',
          className: 'col-12',
          type: InputTypesEnum.ClientForReportSelect,
          disabled: (item) => ExcelDataExportWindowDescription.isClientDisabled(item),
          idFilter: 'Office',
          validityChecker: ExcelDataExportWindowDescription.forRequiredClientField,
        },
        {
          fieldName: 'Project',
          label: 'Project',
          className: 'col-12',
          type: InputTypesEnum.ProjectForReportSelect,
          disabled: (item) => ExcelDataExportWindowDescription.isProjectDisabled(item),
          idFilter: 'Client',
          validityChecker: ExcelDataExportWindowDescription.forRequiredProjectField,
        },
      ],
    },
  ];

  static GetExcelDataReportTypes() {
    return [
      { value: '', label: 'Choose one...' },
      { value: 23, label: 'FW Planning Report' },
      { value: 16, label: 'FW Update' },
      { value: 18, label: 'Planning Completion/Review' },
      { value: 14, label: 'Revenue Analysis' },
      { value: 17, label: 'SAP vs. Caspian Invoice Recon' },
      { value: 25, label: 'Scheduler Report' },
      //{ value: 5, label: 'Status Report', disabled: true }, //Logic is complete but may need slight testing if re-enabled
      { value: 15, label: 'TAT' },
      { value: 13, label: 'Activity Tracker' },
      { value: 21, label: 'Tipalti Not Registered Evaluator Review' },
      { value: 22, label: 'Tipalti Registered Evaluator Review' },
      //{ value: 4, label: 'Workload', disabled: true }, //Logic is complete but may need slight testing if re-enabled
    ];
  }

  static isOfficeDisabled(item) {
    const array = [15, 21, 22];

    //The Office field should only be modifiable if user has global permission
    if (!RoleService.CheckUserPermission('inputfield', 'exceldataexport_office_input')) {
      array.push(18);
    }

    return !item.Report || array.includes(JSON.parse(item.Report));
  }

  static isClientDisabled(item) {
    const array = [4, 5, 13, 14];
    return !item.Report || !array.includes(JSON.parse(item.Report));
  }

  static isProjectDisabled(item) {
    const array = [4, 13, 14];
    return !item.Report || !item.Client || !array.includes(JSON.parse(item.Report));
  }

  static forRequiredOfficeField(e, item) {
    const array = [4, 23, 25];

    if (item.Report && array.includes(JSON.parse(item.Report))) {
      return ValidityHelper.forRequiredMultiSelectField(e);
    }
    return ValidityHelper.AlwaysFlawless();
  }

  static forRequiredClientField(e, item) {
    const array = [];

    if (item.Report && array.includes(JSON.parse(item.Report))) {
      return ValidityHelper.forRequiredSelectField(e);
    }
    return ValidityHelper.AlwaysFlawless();
  }

  static forRequiredProjectField(e, item) {
    const array = [];

    if (item.Report && array.includes(JSON.parse(item.Report))) {
      return ValidityHelper.forRequiredSelectField(e);
    }
    return ValidityHelper.AlwaysFlawless();
  }
}
